import { useEffect } from "react"
import { type useToast } from "@chakra-ui/react"
import { type ApolloError } from "@apollo/client"

interface UseErrorToastProps {
  toast: ReturnType<typeof useToast>
  error: ApolloError | undefined | null | string | { error: { errors: string[] } }
  errorMessage: string
}
const getErrorText = (error: UseErrorToastProps["error"]): string | null | undefined => {
  if (typeof error === "string" || !error) {
    return error
  }

  if ("graphQLErrors" in error) {
    return error?.graphQLErrors?.[0]?.message ?? "An error occurred"
  }

  if ("message" in error) {
    return "An error occurred"
  }

  if ("errors" in error) {
    return (error as { errors: string[] }).errors[0]
  }

  return "something went wrong"
}

const useErrorToast = ({ toast, error, errorMessage }: UseErrorToastProps): void => {
  try {
    useEffect(() => {
      if (error) {
        toast({
          title: errorMessage,
          description: getErrorText(error),
          status: "error",
          duration: 5000,
          isClosable: true
        })
      }
    }, [error, toast, errorMessage])
  } catch (e) {
    // Error handling
  }
}

export default useErrorToast
